import {SET_IS_LOADING, SET_TABLE_LOADING} from "./types";


export const setIsLoading = payload => async dispatch => dispatch({type: SET_IS_LOADING, payload})
export const setTableLoading = payload => async dispatch => dispatch({type: SET_TABLE_LOADING, payload})